export default "__VITE_ASSET__49yA5YMP__"